import OrganizerShowcase from "../components/OrganizerShowcase";

export default function ChallengesHubPage() {
  return <OrganizerShowcase kind="challenges" />;
}
